import { z } from 'zod';
import { ILegalClient } from '../../ILegalClient';
import { GenericLegalTransactionRelationshipMemberSchema } from '../GenericLegalTransactionRelationshipMemberSchema';
import { getEmptyMemberSkeleton } from '../ILegalTransactionRelationshipMember';
import { LegalTransactionRelationshipRoleEnum } from '../LegalTransactionRelationshipRoleEnum';

export const SpouseMemberDataSchema = z.object({});

export type ISpouseMemberData = z.infer<typeof SpouseMemberDataSchema>;

export const SpouseMemberSchema =
  GenericLegalTransactionRelationshipMemberSchema(
    z.literal(LegalTransactionRelationshipRoleEnum.Spouse),
    SpouseMemberDataSchema
  );

export type IMemberSpouse = z.infer<typeof SpouseMemberSchema>;

export const getEmptyMemberSpouseData = (): ISpouseMemberData => ({});

export function getEmptySpouseMember(
  legalClient: ILegalClient,
  idRelationship: number,
  data?: ISpouseMemberData
): IMemberSpouse {
  const member: IMemberSpouse = {
    ...getEmptyMemberSkeleton(legalClient, idRelationship),
    idRelationshipRole: LegalTransactionRelationshipRoleEnum.Spouse,
    data: data || getEmptyMemberSpouseData(),
  };

  return member;
}
